import React, { useState } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { colors } from "../../style";

const ACTION_BAR_HEIGHT = "80px";

const style = {
  actionBarFull: {
    maxWidth: "90vw",
    backgroundColor: colors.raised,
    border: `1px solid ${colors.borderStrong}`,
    boxShadow: "0 12px 32px rgba(0, 0, 0, 0.35)",
    height: ACTION_BAR_HEIGHT,
    display: "flex",
    alignItems: "center",
    padding: "0 1.2rem",
    borderRadius: "20px",
    marginBottom: "20px",
    zIndex: 4,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  actionBarMin: {
    width: "100%",
    height: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 4,
  },
};

function ActiveCallActionBar({
  minimized,
  setMinimized,
  activeCall,
  handleHangup,
  handleConferenceComplete,
  isConferenceable = false,
  hideDefaultActions,
  children,
}) {
  const disconnecting = activeCall?.state === "disconnecting";

  return (
    <div style={minimized ? style.actionBarMin : style.actionBarFull}>
      {!minimized && <>{children}</>}

      {!hideDefaultActions && (
        <>
          <MinMaxButton minimized={minimized} setMinimized={setMinimized} />
          {isConferenceable && (
            <JoinConferenceButton
              activeCall={activeCall}
              minimized={minimized}
              handleConferenceComplete={handleConferenceComplete}
            />
          )}
          <HangupButton
            activeCall={activeCall}
            minimized={minimized}
            disconnecting={disconnecting}
            handleHangup={handleHangup}
          />
        </>
      )}
    </div>
  );
}

function MinMaxButton({ minimized, setMinimized }) {
  return (
    <Popup
      content={minimized ? "Maximize" : "Minimize"}
      position={minimized ? "top right" : "top center"}
      trigger={
        <Button color="black" onClick={() => setMinimized(!minimized)} icon>
          <Icon name={minimized ? "expand" : "window minimize"} />
        </Button>
      }
    />
  );
}

function JoinConferenceButton({
  activeCall,
  minimized,
  disconnecting,
  handleConferenceComplete,
}) {
  const [joining, setJoining] = useState(false);

  const handleClick = () => {
    setJoining(true);
    handleConferenceComplete();
  };

  return (
    <Button
      loading={joining}
      disabled={!activeCall || disconnecting}
      color="primary"
      onClick={handleClick}
      icon={minimized}
    >
      <Icon name="user add" />
      {!minimized && "Join"}
    </Button>
  );
}

function HangupButton({ activeCall, minimized, disconnecting, handleHangup }) {
  return (
    <Button
      loading={disconnecting}
      disabled={!activeCall || disconnecting}
      color="red"
      onClick={handleHangup}
      icon={minimized}
    >
      <Icon name="user close" />
      {!minimized && "End Call"}
    </Button>
  );
}

export default ActiveCallActionBar;
